import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'sku-reports.items.page-title',
    defaultMessage: 'Item reports',
  },
  topSellerTile: {
    id: 'sku-reports.items.tile-top-seller',
    defaultMessage: 'Top seller (units)',
  },
  topEarnerTile: {
    id: 'sku-reports.items.tile-top-earner',
    defaultMessage: 'Top earner (revenue)',
  },
  topSellerSubtitle: {
    id: 'sku-reports.items.tile-top-seller-subtitle',
    defaultMessage: '{count, plural, one {# unit} other {# units}} sold this period',
  },
  topSellerSubtitleWithCurrency: {
    id: 'sku-reports.items.tile-top-seller-subtitle-currency',
    defaultMessage: '{count, plural, one {# unit} other {# units}} sold this period ({currency})',
  },
  topEarnerSubtitle: {
    id: 'sku-reports.items.tile-top-earner-subtitle',
    defaultMessage: '{amount} earned this period',
  },
  itemsCount: {
    id: 'sku-reports.items.items-count',
    defaultMessage: '{count, plural, one {# item} other {# items}}',
  },
  locationsCount: {
    id: 'sku-reports.items.locations-count',
    defaultMessage: '{count, plural, one {# location} other {# locations}}',
  },
  itemColumn: {
    id: 'sku-reports.items.column-item',
    defaultMessage: 'Item',
  },
  locationColumn: {
    id: 'sku-reports.items.column-location',
    defaultMessage: 'Location',
  },
  menuColumn: {
    id: 'sku-reports.items.column-menu',
    defaultMessage: 'Menu',
  },
  categoryColumn: {
    id: 'sku-reports.items.column-category',
    defaultMessage: 'Category',
  },
  unitsSoldColumn: {
    id: 'sku-reports.items.column-units-sold',
    defaultMessage: 'Units sold',
  },
  ordersColumn: {
    id: 'sku-reports.items.column-orders',
    defaultMessage: 'Orders',
  },
  earningsColumn: {
    id: 'sku-reports.items.column-earnings',
    defaultMessage: 'Earnings',
  },
  toggleBreakdown: {
    id: 'sku-reports.items.toggle-breakdown',
    defaultMessage: 'Location breakdown for {name}',
  },
  categoryFilterLabel: {
    id: 'sku-reports.items.filter-category',
    defaultMessage: '{count, plural, =0 {All categories} other {Categories (#)}}',
  },
  menuFilterLabel: {
    id: 'sku-reports.items.filter-menu',
    defaultMessage: '{count, plural, =0 {All menus} other {Menus (#)}}',
  },
  uncategorized: {
    id: 'sku-reports.items.filter-uncategorized',
    defaultMessage: 'Uncategorized',
  },
  searchPlaceholder: {
    id: 'sku-reports.items.search-placeholder',
    defaultMessage: 'Search by item name',
  },
  searchSuggestions: {
    id: 'sku-reports.items.search-suggestions',
    defaultMessage: 'Search suggestions',
  },
  downloadCsv: {
    id: 'sku-reports.items.download-csv',
    defaultMessage: 'Download CSV',
  },
  csvExportStarted: {
    id: 'sku-reports.items.csv-export-started',
    defaultMessage: 'Downloading item report',
  },
  errorTitle: {
    id: 'sku-reports.items.error-title',
    defaultMessage: "We couldn't load your items",
  },
  errorBody: {
    id: 'sku-reports.items.error-body',
    defaultMessage: 'Something went wrong on our end. Please try again.',
  },
  retry: {
    id: 'sku-reports.items.retry',
    defaultMessage: 'Try again',
  },
  emptyTitle: {
    id: 'sku-reports.items.empty-title',
    defaultMessage: 'No items found',
  },
  emptyBody: {
    id: 'sku-reports.items.empty-body',
    defaultMessage: 'Try selecting another location or date range',
  },
});
